import { render, staticRenderFns } from "./lecture-purchase-dialog.vue?vue&type=template&id=531700a7"
import script from "./lecture-purchase-dialog.vue?vue&type=script&lang=js"
export * from "./lecture-purchase-dialog.vue?vue&type=script&lang=js"
import style0 from "./lecture-purchase-dialog.vue?vue&type=style&index=0&id=531700a7&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports